import React from "react";
import { IconSquareRoundedArrowRightFilled } from "@tabler/icons-react";

import * as styles from "./FigmaToCode.module.scss";

const FigmaToCode = () => {
  return (
    <section className="bx--grid bx--col-lg-12">
      <div className={styles.container}>
        <article>
          <div className={styles.inlineContainer}>
            <span className={styles.newFeatures}><span className={styles.dot}></span>New features</span>
          </div>
          <h1>Clicking is Believing with Legion AI</h1>
          <p>Speed up your prototyping process with our AI-powered tools.</p>
          <a
            href="https://legionai-stage.telkomdigital.id/"
            target="_blank"
            rel="noopener noreferrer"
            className={styles.button}
          >
            Let's Try <IconSquareRoundedArrowRightFilled />
          </a>
        </article>
        <object type="image/svg+xml" data="/images/bannerlegionai.svg" aria-label="figma to code illustration">
          Figma to Code Illustration
        </object>
      </div>
    </section>
  );
};

export default FigmaToCode;

